import { Container } from '@cloudscape-design/components';
import { Header } from '@cloudscape-design/components';
import { SpaceBetween } from '@cloudscape-design/components';
import { PlaceContact, ReviewContact } from '../../../common/types';
import { ReviewContent } from '../../../components/ReviewContent';
import { formatDateString } from '../../../common/formatting/dateFormat';
import { ReviewText } from '../../../components/ReviewText';
import { useMemo } from 'react';
import { formatPhoneNumber } from '../../../common/formatting/phoneFormat';
import { ReviewList } from '../../../components/ReviewList';

export type ContactReviewsViewProps = {
  contacts: ReviewContact[];
  contact: PlaceContact;
};

export function ContactReviewsView(props: ContactReviewsViewProps) {
  const { contact, contacts } = props;

  const highlights = useMemo(() => {
    const highlights: string[] = [];
    if (contact.first_name) {
      highlights.push(contact.first_name);
    }
    if (contact.last_name) {
      highlights.push(contact.last_name);
    }
    if (contact.phone_number) {
      highlights.push(formatPhoneNumber(contact.phone_number));
      highlights.push(contact.phone_number);
      highlights.push(
        formatPhoneNumber(contact.phone_number).replace(/[()]/g, '').replaceAll(' ', '-'),
      );
    }
    if (contact.email) {
      highlights.push(contact.email);
    }
    if (contact.title) {
      highlights.push(contact.title);
    }
    if (contact.department) {
      highlights.push(contact.department);
    }
    return highlights;
  }, [contact]);

  return (
    <ReviewList
      reviews={contacts.map((reviewContact: ReviewContact) => reviewContact.review)}
      placeName={contact.place.name}
      header={<Header variant="h2">Reviews</Header>}
    />
  );
}
